import FormattedMessage from 'I18n/components/FormattedMessage';
import { InlineLabel } from 'foundations-components/transitional/components/InlineLabel';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { Select } from 'foundations-components/transitional/components/Select';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { useAssetSortOptions } from '../../../hooks/useAssetSortOptions';
import { jsx as _jsx } from "react/jsx-runtime";
export function AssetSortToggleGroup({
  onSelect,
  value,
  isUnifiedSearch
}) {
  const assetSortOptions = useAssetSortOptions(isUnifiedSearch);
  return /*#__PURE__*/_jsx(ToggleGroup, {
    name: "sort",
    children: assetSortOptions.map(option => /*#__PURE__*/_jsx(RadioInput, {
      checked: option.value === value,
      onChange: () => onSelect(option.value),
      children: option.text
    }, option.value))
  });
}
export function AssetSortDropdown({
  disabled,
  isUnifiedSearch,
  onSelect,
  value
}) {
  const assetSortOptions = useAssetSortOptions(isUnifiedSearch);
  return /*#__PURE__*/_jsx(InlineLabel, {
    marginInlineEnd: "0",
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-assets-ui.themes.sort.label"
    }),
    children: /*#__PURE__*/_jsx(Select, {
      buttonUse: "transparent",
      disabled: disabled,
      menuWidth: 250,
      onChange: event => onSelect(event.target.value),
      options: assetSortOptions,
      searchable: false,
      value: value
    })
  });
}